import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { SecureRoute } from './common/authentication';
import HomePage from './pages/HomePage';
import DashboardsPage from './pages/DashboardsPage';
import DashboardPage from './pages/DashboardPage';
import UploadsPage from './pages/UploadsPage';
import UploadPage from './pages/IngestPage';
import BepFieldSpecPage from './pages/BepFieldSpecPage';
import FepSpotFieldSpecPage from './pages/FepSpotFieldSpecPage';
import FepLinearFieldSpecPage from './pages/FepLinearFieldSpecPage';
import FepNonLinearFieldSpecPage from './pages/FepNonLinearFieldSpecPage';
import RepFieldSpecPage from './pages/RepFieldSpecPage';
import HelpPage from './pages/HelpPage';
import AboutPage from './pages/AboutPage';
import AccountPage from './pages/AccountPage';
import MappingAdminPage from './pages/MappingAdminPage';
import MappingAuditPage from './pages/MappingAuditPage';
import NotFoundPage from './pages/NotFoundPage';

import DashboardEditor from './pages/DashboardEditor';
import config from './config';

class App extends React.Component {
  render() {
    return (
      <Router>
        <Switch>
          <SecureRoute exact path="/" notSecure={() => <HomePage />}>
            <Redirect from="/" to="/dashboards" />
          </SecureRoute>
          <SecureRoute exact path="/dashboard/:viz_id">
            <DashboardPage />
          </SecureRoute>
          <SecureRoute exact path="/field-spec/bonds">
            <BepFieldSpecPage />
          </SecureRoute>
          <SecureRoute exact path="/field-spec/irs">
            <RepFieldSpecPage />
          </SecureRoute>
          <SecureRoute exact path="/field-spec/spot">
            <FepSpotFieldSpecPage />
          </SecureRoute>
          <SecureRoute exact path="/field-spec/forwards">
            <FepLinearFieldSpecPage />
          </SecureRoute>
          <SecureRoute exact path="/field-spec/options">
            <FepNonLinearFieldSpecPage />
          </SecureRoute>
          <SecureRoute exact path="/uploads">
            <UploadsPage />
          </SecureRoute>
          <SecureRoute exact path="/upload">
            <UploadPage />
          </SecureRoute>
          <SecureRoute exact path="/help">
            <HelpPage />
          </SecureRoute>
          <SecureRoute exact path="/about">
            <AboutPage />
          </SecureRoute>
          <SecureRoute exact path="/account">
            <AccountPage />
          </SecureRoute>
          <SecureRoute exact path="/dashboards/:assetclassId?">
            <DashboardsPage />
          </SecureRoute>
          <SecureRoute exact path="/dashboardeditor">
            {/* The builder is ThoughtSpot's; Jitto Answer has none. */}
            {config.jittoEmbedActiveFlag ? (
              <Redirect to="/dashboards" />
            ) : (
              <DashboardEditor />
            )}
          </SecureRoute>
          <SecureRoute exact path="/data-mapping-admin">
            <Redirect to="/data-mapping-admin/rates-field" />
          </SecureRoute>
          <SecureRoute exact path="/data-mapping-admin/rates-field">
            <MappingAdminPage />
          </SecureRoute>
          <SecureRoute exact path="/data-mapping-admin/rates-fixing">
            <MappingAdminPage />
          </SecureRoute>
          <SecureRoute exact path="/data-mapping-admin/legal-entity">
            <MappingAdminPage />
          </SecureRoute>
          <SecureRoute exact path="/data-mapping-audit">
            <Redirect to="/data-mapping-audit/rates-field" />
          </SecureRoute>
          <SecureRoute exact path="/data-mapping-audit/rates-field">
            <MappingAuditPage />
          </SecureRoute>
          <SecureRoute exact path="/data-mapping-audit/rates-fixing">
            <MappingAuditPage />
          </SecureRoute>
          <SecureRoute exact path="/data-mapping-audit/legal-entity">
            <MappingAuditPage />
          </SecureRoute>
          <Route>
            <NotFoundPage />
          </Route>
        </Switch>
      </Router>
    );
  }
}

export default App;
